import { logn } from '@Utils/PikaLog'
import { makeAutoObservable } from 'mobx'

const SERVER_URLS = {
    development: `wss://ushop-io.unicity.com/io_dev`,
    production: `wss://ushop-io.unicity.com/io`,
}
const IO_SERVICE = `newsUnread`
const IO_ALIAS = `IoNewsUnread`

const { REACT_APP_ENV, NODE_ENV } = process.env
const USE_STAGE = REACT_APP_ENV || NODE_ENV
const SERVER_URL = SERVER_URLS[USE_STAGE]

const toQueryString = obj => {
    const params = Object.keys(obj).reduce((list, key) => {
        list.push(`${key}=${obj[key]}`)
        return list
    }, [])
    return params.length > 0 ? `?${params.join("&")}` : ``
}

const logInfo = (...messages) => logn(`[${IO_ALIAS}]`, ...messages)

class StoreIoNewsUnread {
    isConnecting = false
    isCallbackOnConnect = false
    client = null
    data = null
    isSentOpenData = false

    // for re-connecting
    countryCode = null
    baId = null
    onData = null

    constructor() {
        makeAutoObservable(this)
    }

    _send(obj) {
        if (this.client && this.client.readyState === 1) {
            this.client.send(JSON.stringify(obj))
        } else {
            this.open({
                countryCode: this.countryCode,
                baId: this.baId,
            }, {
                onData: this.onData,
                onConneced: () => this.client.send(JSON.stringify(obj)) // send after opened
            })
            logInfo(`send failed socket is closed`)
        }
    }

    getLastUpdate() {
        this._send({ service: IO_SERVICE, action: "get" })
    }

    open({
        countryCode,
        baId,
    }, 
    { 
        onData, 
        onConneced,
    }) {
        // for re-connecting
        this.countryCode = countryCode
        this.baId = baId
        if (onData) this.onData = onData

        const queryString = toQueryString({
            service: IO_SERVICE,
            countryCode,
            baId,
        })
        const connectUrl = `${SERVER_URL}${queryString}`
        logInfo(`Connecting...`, connectUrl)

        this.client = new WebSocket(connectUrl)
        this.client.addEventListener('open', () => {
            logInfo('connected')
            this.isConnecting = true
            onConneced && onConneced()
        })

        this.client.addEventListener('close', e => {
            logInfo('closed')
            if (this.isConnecting) this.open({
                countryCode,
                baId,
            }, 
            { 
                onData, 
                onConneced,
            })
        })

        this.client.addEventListener('message', e => {
            logInfo('message', e.data)
            const res = JSON.parse(e.data)

            if (res.action === "onData") {
                this.data = res.data
                this.onData && this.onData(res)
            }
        })

        this.client.addEventListener('error', e => {
            console.error(e)
        })
    }

    close() {
        this.client.close()
        this.data = null
        this.client = null
        this.isConnecting = false
    }

    setOne(data) {
        logInfo('setOne', data)
        this._send({ service: IO_SERVICE, action: "setOne", data })
    }
}

export default new StoreIoNewsUnread()